import { IMLayout, useTheme } from '@infominds/react-native-components'
import { LoginScreen as IMLoginScreen } from '@infominds/react-native-license'
import React from 'react'
import { SafeAreaView } from 'react-native-safe-area-context'

import KeyboardAware from '../components/KeyboardAware'
import DemoMode from '../constants/DemoMode'

export default function LoginScreen() {
  const { colorScheme } = useTheme()

  const colors = { dark: { background: '#1E1E1E' }, light: { background: '#F5F5F5' } }

  return (
    <SafeAreaView style={[IMLayout.flex.f1, { backgroundColor: colorScheme === 'light' ? colors.light.background : colors.dark.background }]}>
      <KeyboardAware>
        <IMLoginScreen
          demoData={{
            license: DemoMode.DEMO_LICENSE_KEY,
            username: DemoMode.DEMO_USERNAME,
            password: DemoMode.DEMO_PASSWORD,
          }}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          iconSource={require('../assets/images/app_logo.png')}
          disableStatusBar
          keyboardAvoiding={false}
          colorScheme={colorScheme}
          overrideThemeColors={colors}
        />
      </KeyboardAware>
    </SafeAreaView>
  )
}
